import React, { useState, useEffect } from "react";
import { ArrowIcon } from "shared-components/Components/CustomIcons/ArrowIcon/web";
import "./styles.less";

interface BoxOption {
  id?: string | number;
  value?: string | number;
  text?: string;
  nombre?: string;
  plural?: string;
  icon?: React.ComponentType<any>;
  property_type_id?: number;
  [key: string]: any;
}

interface BoxesContainerProps {
  options: BoxOption[];
  selectedValues: any;
  isItemActive: (option: BoxOption, index?: number) => boolean;
  onItemClick: (option: BoxOption) => void;
  showUpTo?: number | null;
  renderItem?: (option: BoxOption, isActive: boolean) => React.ReactNode;
  containerClassName?: string;
  itemClassName?: string;
}

export const BoxesContainer: React.FC<BoxesContainerProps> = ({
  options,
  selectedValues,
  isItemActive,
  onItemClick,
  showUpTo = null,
  renderItem,
  containerClassName = "",
  itemClassName = "",
}) => {
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    if (showUpTo && showUpTo < options?.length && Array.isArray(selectedValues)) {
      // For array-based selectedValues (like PropertyType)
      const result = selectedValues.some(val => {
        const index = options.findIndex(option => 
          option.property_type_id === val || option.id === val || option.value === val
        );
        return index >= showUpTo;
      });
      
      if (result) {
        setShowMore(true);
      }
    } else if (showUpTo && showUpTo < options?.length && typeof selectedValues === "number") {
      // For single value selectedValues (like PublicationDate)
      const index = options.findIndex(option => 
        option.value === selectedValues || option.id === selectedValues
      );
      if (index >= showUpTo) {
        setShowMore(true);
      }
    }
  }, [selectedValues, options, showUpTo]);

  const defaultRenderItem = (option: BoxOption, isActive: boolean) => {
    return (
      <div
        key={option.id || option.value || option.property_type_id}
        className={`boxes-container__item ${isActive ? "boxes-container__item--active" : ""} ${itemClassName}`}
        onClick={() => onItemClick(option)}
      >
        {option.icon && (
          <span className="icon-container">
            <option.icon />
          </span>
        )}
        <span className="box-text">{option.text || option.nombre || option.plural}</span>
      </div>
    );
  };

  return (
    <div className={`boxes-container ${containerClassName}`}>
      {options.map((option, index) => {
        const shouldRender = !showUpTo || showMore || (index < showUpTo && !showMore);
        if (!shouldRender) return null;
        
        const isActive = isItemActive(option, index);
        return renderItem ? renderItem(option, isActive) : defaultRenderItem(option, isActive);
      })}

      {showUpTo && options.length > showUpTo && (
        <div className="show-more__container">
          <button 
            onClick={() => setShowMore(!showMore)}
            className="show-more__button"
          >
            <span>{showMore ? 'Ver menos' : 'Ver más'}</span>
            {showMore ? <ArrowIcon type="top" /> : <ArrowIcon type="bottom" />}
          </button>
        </div>
      )}
    </div>
  );
}; 